import { ReceivableListPage } from "@/components/ReceivableListPage";

export default function RecurringReceivables() {
  return <ReceivableListPage kind="recurring" />;
}
